import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { Button } from '@workspace/ui/components/Button';
import { cn } from '@workspace/ui/lib/utils';

import Icon from '~/components/Icon/Icon';
import { ModalType } from '~/components/Modal/interface';
import { useModal } from '~/hooks/useModal';
import { CLUB_CLASS } from '~/modules/membership/ui/club/clubStyles';
import { useIsClubMember } from '~/modules/membership/ui/club/useClubEntry';
import { userStore } from '~/stores';

const iconButtonClasses =
  'size-12! max-h-none! p-0! border-transparent bg-navigation-surface text-navigation-icon-primary hover:bg-navigation-surface-2';

/** Account button of the header; a club member with active benefits gets the orange club gradient. */
export const ProfileButton = observer(() => {
  const { openModal } = useModal();
  const navigate = useNavigate();
  const isClubMember = useIsClubMember();

  const profilePath = '/cabinet';

  const handleClick = () => {
    if (!userStore.isAuthorized) {
      openModal(ModalType.Auth, 'header', { redirect: profilePath });
      return;
    }
    navigate(profilePath);
  };

  return (
    <Button
      variant="secondary"
      startIcon={<Icon type="profile-3.1" width={20} height={19} />}
      className={cn(
        iconButtonClasses,
        isClubMember && [CLUB_CLASS.orange, 'text-white hover:opacity-90'],
      )}
      onClick={handleClick}
      data-button="header-cabinet"
    />
  );
});
